var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter, Routes, Route } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { getElement, getUserData } from "./config/common";
import { useEffect } from "react";
import { Room, trackEvent } from "@tk-events/fw";
import rooms from "./venue/components/rooms";
import "./venue/tkevents.css";
var history = [];
// onChange={handleNewRoute}
var App = function (_a) {
    var _b = _a.links, links = _b === void 0 ? [] : _b;
    var nav = useNavigate();
    var location = useLocation();
    useEffect(function () {
        var dt = new Date().getTime();
        if (window.lastPageLoad && window.lastPageLoad < (dt - 1000 * 3600 * 2)) {
            window.location.href = "https://isfcongress.tkeventsregistration.com/2022/";
            nav(-1);
        }
        window.lastPageLoad = new Date();
        history.push(location.pathname);
        var previous = null;
        if (history.length > 1) {
            previous = history[history.length - 2];
        }
        trackEvent({
            eventID: 67089,
            from: (previous === null || previous === void 0 ? void 0 : previous.replace(/^\//g, "").replace(/^$/g, "Atrium")) || null,
            to: location.pathname.replace(/^\//g, "").replace(/^$/g, "Atrium"),
            type: "Venue Navigation",
            userID: getUserData().regId,
        });
    }, [location]);
    return React.createElement(React.Fragment, null,
        React.createElement(Routes, null,
            " ",
            links.map(function (it) {
                var path = it.path || "/" + it.name.replace(/ /g, "-").replace(/[^A-z-]/g, "");
                return React.createElement(Route, { key: path, path: path, element: React.createElement(Room, __assign({}, it)) });
            }),
            " "),
        React.createElement("div", { id: "modals" }),
        React.createElement("script", { src: "https://apps.elfsight.com/p/platform.js", defer: true }));
};
createRoot(getElement("app")).render(React.createElement(HashRouter, null,
    React.createElement(App, { links: rooms })));
